export default "__VITE_ASSET__Bh7EBSLH__"